import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Col, Row, Form, Modal } from 'react-bootstrap'
import { ContactButton, InputWithIcon, NextBackButton } from '../../../ui/CustomElements'
import { Box, InnerHeading, LabelStyled, LazyImage, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowRight, BackArrow, NextArrow, SuccessLogo } from '../../../ui/AllImages'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useForm } from "react-hook-form";
import MapSearchSelect from '../../map/mapInput'
import ContactApi from '../../../services/api/contactApi'
import { toast } from 'react-toastify'
import ValidatedInput from '../../inputFields/ValidatedInput'
const StepOne = ({ nextStep, formData, setFormData }) => {
    const { t, i18n } = useTranslation();
    const [currentStep, setCurrentStep] = useState(1);
    const [phone, setPhone] = useState("");
    const [errorField, setErrorField] = useState("");
    const [errorEmail, setErrorEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: formData,
    });
    const onSubmit = async (data) => {
        try {
            setLoading(true);
            const response = await ContactApi.submitForm({ ...data, step: 1 }, i18n.language);
            if (response.code === 200) {
                const requestId = response.data.quote_request_id;
            setFormData({ ...data, id: requestId });
                nextStep();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("Error submitting Step 1:", error);
        } finally {
            setLoading(false);
          }
    };
    return (
        <ContacFormWapper className='contactFormWrapper'>
            <Box>
                <Box className=''>
                    <Box className='d-flex flex-column align-items-start justify-content-start contactHeading'>
                        <InnerHeading className='' lh="1.2" size="22px" color="var(--themeColor)">{t('PersonalInformation')}</InnerHeading>
                    </Box>
                </Box>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className=''>
                        <Col lg={12} className='py-2 inputCol'>
                            <ValidatedInput
                                name="full_name"
                                type="input"
                                fieldType="text"
                                placeholder={t('NameP')} 
                                label={t('FullName')}
                                register={register}
                                errors={errors}
                                validationRules={{
                                required: true,
                                }}
                            />
                        </Col>
                        <Col lg={12} md={12} className='py-2 inputCol'>
                             <ValidatedInput
                                name="phone"
                                type="input"
                                fieldType="text"
                                placeholder={t('PhoneP')} 
                                label={t('Phone')}
                                register={register}
                                errors={errors}
                                maxLength={10}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                    if (e.target.value.length > 0 && e.target.value[0] !== "5") {
                                        e.target.value = ""; 
                                    }
                                }}
                                validationRules={{
                                required: true,
                                }}
                            />
                            {errorField && <p className="text-danger text-sm mb-0 mt-1 commonError">{errorField}</p>}
                        </Col>
                        <Col lg={12} md={12} className='py-2 inputCol'>
                            <ValidatedInput
                                name="email"
                                type="input"
                                fieldType="text"
                                placeholder={t('EmailP')} 
                                label={t('Email')}
                                register={register}
                                errors={errors}
                                onInput={(e) => {
                                    const value = e.target.value;
                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    if (!emailRegex.test(value)) {
                                        setErrorEmail("Pleaseentervalidemail");
                                    } else {
                                        setErrorEmail("");
                                    }
                                    if (value === "") {
                                        setErrorEmail("");
                                        return;
                                    }
                                }}
                                validationRules={{
                                    required: true,
                                }}
                            />
                            {errorEmail && <p className="text-danger text-sm mb-0 mt-1 commonError">{t(errorEmail)}</p>}
                        </Col>
                        <Box className='d-flex justify-content-between w-100 mt-5 btnNBWrap'> 
                            <NextBackButton type="button" className="" disabled content='end' backIcon={BackArrow} label={t('back')} bg="var(--greyBg)" />
                            <Box className="nextTextContainer">
                                <Box className='progressTextContainer'>
                                    <SpanStyled className='txtEng'>
                                        1
                                    </SpanStyled>
                                    <SpanStyled className='ofProgTxt'>
                                        {t("Of")}
                                    </SpanStyled>
                                    <SpanStyled className='txtEng'>
                                        5
                                    </SpanStyled>
                                </Box>
                                <NextBackButton 
                                    type="submit" 
                                    className=""
                                    nextIcon={NextArrow} 
                                    label={t('next')} 
                                    isLoading={loading}
                                />
                            </Box>
                        </Box>
                    </Row>
                </Form>
            </Box>
        </ContacFormWapper >
    )
}
const ContacFormWapper = styled.div`
    /* margin:30px 0; */
`
export default StepOne
